import { RefObject, useEffect, useRef } from 'react';

function useClickAway(ref: RefObject<HTMLElement>, onClick: () => void) {
	const onClickRef = useRef(onClick);

	useEffect(() => {
		onClickRef.current = onClick;
	}, [onClick]);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			const targetNode = event.target as Node | null;
			if (targetNode) {
				if (ref.current && !ref.current.contains(targetNode)) {
					onClickRef.current();
				}
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref]);
}

export { useClickAway };
